import httpClient from "./httpClient";

export function getMenu() {
  return httpClient.get("/menu").then((res) => res.data.data);
}

export function getMenuCatalog() {
  return httpClient.get("/menu/catalog").then((res) => res.data.data);
}
